import { Notifier } from "@airbrake/browser";

if (window.env.JEKYLL_ENV === "production") {
  try {
    window.airbrake = new Notifier({
      projectId: window.env.AIRBRAKE_PROJECT_ID,
      projectKey: window.env.AIRBRAKE_PROJECT_KEY,
      host: "https://panel.sutty.ar",
    });

    console.originalError = console.error;
    console.error = (...e) => {
      window.airbrake.notify(e.join(" "));
      return console.originalError(...e);
    };
  } catch (e) {
    console.error(e);
  }
}

import * as Turbo from "@hotwired/turbo";
Turbo.start();

import { Application } from "@hotwired/stimulus";
window.Stimulus = Application.start();
window.abortController = undefined;

import ButtonCopyController from "./controllers/button_copy_controller";
import RequiredCheckboxController from "./controllers/required_checkbox_controller";
import DateOfBirthController from "./controllers/date_of_birth_controller";
import FormDependenciesController from "./controllers/form_dependencies_controller";
import FormValidationController from "./controllers/form_validation_controller";
import NestedFormController from "./controllers/nested_form_controller";

Stimulus.debug = window.env.JEKYLL_ENV !== "production";

Stimulus.register("button-copy", ButtonCopyController);
Stimulus.register("required-checkbox", RequiredCheckboxController);
Stimulus.register("dob", DateOfBirthController);
Stimulus.register("form-dependencies", FormDependenciesController);
Stimulus.register("form-validation", FormValidationController);
Stimulus.register("nested-form", NestedFormController);

document.addEventListener("turbo:load", (event) => {
  window.abortController = new AbortController();
});

document.addEventListener("turbo:visit", (event) => {
  window.abortController.abort();
});
